

export function ExtensionDownload() {
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '40px', fontFamily: 'sans-serif', lineHeight: 1.6, color: '#e2e8f0' }}>
      <h1 style={{ color: '#fff', marginBottom: '8px' }}>VeloStruct Agent Bridge Extension</h1>
      <p style={{ color: '#94a3b8', fontSize: '18px', marginBottom: '32px' }}>
        Install the extension locally to connect your AI agents (Claude Code, Windsurf, Cursor) directly to this tab.
      </p>

      <div style={{ backgroundColor: '#1e293b', padding: '24px', borderRadius: '8px', marginBottom: '40px', border: '1px solid #334155' }}>
        <a 
          href="/velostruct-extension.zip" 
          download 
          style={{
            display: 'inline-block',
            backgroundColor: '#3b82f6',
            color: '#fff',
            padding: '12px 24px',
            borderRadius: '6px',
            textDecoration: 'none',
            fontWeight: 'bold',
            fontSize: '16px',
            marginBottom: '16px'
          }}
        >
          Download Extension (.zip)
        </a>
        <p style={{ margin: 0, fontSize: '14px', color: '#94a3b8' }}>
          Latest build • Requires Chrome or Edge
        </p>
      </div>

      <h2 style={{ color: '#60a5fa', marginTop: '32px' }}>How to Install (Unpacked)</h2>
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: '24px', marginTop: '24px' }}>
        <div>
          <h3 style={{ color: '#e2e8f0', margin: '0 0 8px 0' }}>Step 1: Extract the zip</h3>
          <p style={{ margin: 0, color: '#94a3b8' }}>Unzip the downloaded <code>velostruct-extension.zip</code> file to a folder on your computer.</p>
        </div>
        
        <div>
          <h3 style={{ color: '#e2e8f0', margin: '0 0 8px 0' }}>Step 2: Open Extension Settings</h3>
          <p style={{ margin: 0, color: '#94a3b8' }}>Open Google Chrome and navigate to <code style={{ backgroundColor: '#0f172a', padding: '2px 6px', borderRadius: '4px' }}>chrome://extensions</code> in your address bar.</p>
        </div>
        
        <div>
          <h3 style={{ color: '#e2e8f0', margin: '0 0 8px 0' }}>Step 3: Enable Developer Mode</h3>
          <p style={{ margin: 0, color: '#94a3b8' }}>Toggle the <strong>Developer mode</strong> switch in the top-right corner of the extensions page.</p>
        </div>
        
        <div>
          <h3 style={{ color: '#e2e8f0', margin: '0 0 8px 0' }}>Step 4: Load Unpacked</h3>
          <p style={{ margin: 0, color: '#94a3b8' }}>Click the <strong>Load unpacked</strong> button that appears in the top-left, and select the folder where you extracted the extension in Step 1.</p>
        </div>
      </div>

      <div style={{ marginTop: '48px', paddingTop: '24px', borderTop: '1px solid #334155' }}>
        <a href="/edit" style={{ color: '#60a5fa', textDecoration: 'none' }}>&larr; Back to VeloStruct</a>
      </div>
    </div>
  );
}
